import { createActions } from 'redux-actions';

import types from 'state/downloads/actionTypes';

const { downloads } = createActions({
  [types.downloadFile$]: ({ fileType, dateFrom }) => ({ fileType, dateFrom }),
  [types.setDownloadRequestSuccessful]: ({ success }) => ({ success }),
  [types.setDownloadSubmitting]: ({ submitting }) => ({ submitting }),
});

export default downloads;
